module.exports = __webpack_public_path__ + "img/Tele_Consult.654fa3c7.png";